<template>
  <div>
    <b-modal
      ref="ModalUnitAndBatch"
      no-close-on-backdrop
      size="xl"
      title="Sales"
      hide-footer
      @cancel="hideModal"
    >
      <b-row>
        <b-col cols="4">
          <v-select
            v-model="selectedCustomer"
            class="select_"
            :get-option-label="(option) => option.name"
            :options="customerSearchList"
            placeholder="Select Customer"
            @search="searchCustomer"
            @input="onChangeCustomer"
          />
        </b-col>
        <b-col cols="4">
          <v-select
            v-model="selectedShop"
            class="select_"
            :get-option-label="(option) => option.name"
            :options="shopSearchList"
            placeholder="Select Shop "
            @search="searchShop"
            @input="onChangeShop"
          />
        </b-col>
        <b-col cols="4" class="float-end">
          <input
            v-model="query"
            type="string"
            class="form-control"
            placeholder="search"
            style="margin-bottom: 10px; border-radius: 10px"
            @input="fetchSales"
          />
        </b-col>
      </b-row>
      <b-row v-if="loading && loading1" class="d-flex justify-content-center">
        <b-spinner
          style="width: 3rem; height: 3rem"
          variant="primary"
          label="Spinning"
        />
      </b-row>
      <b-row v-if="sales.length == 0 && !loading" class="pl-3 pr-3 text-center">
        <b-col>
          <b-alert show variant="warning"> No Sales Found </b-alert>
        </b-col>
      </b-row>
      <!-- Sale List -->
      <b-row v-if="sales.length != 0 && !loading">
        <b-col cols="12" class="text-center">
          <table class="table table-hover table-striped">
            <tbody>
              <tr>
                <th class="text-center">Reference Number</th>
                <th class="text-center">Date</th>
                <th class="text-center">Amount</th>
                <th class="text-center">Number of Items</th>
                <th class="text-center">Customer</th>
                <th class="text-center">Shop</th>
                <th class="text-center">Type</th>
                <th class="text-center">Status</th>
                <th class="text-center">Action</th>
              </tr>
              <tr
                v-for="(item, index) in sales"
                :key="index"
                style="border-bottom: 1px solid #c1c1c1"
              >
                <td class="text-center">
                  {{ item.reference_number }}
                </td>
                <td class="text-center">
                  {{ moment(item.date) }}
                </td>
                <td class="text-center">
                  {{ item.grand_total }}
                </td>
                <td class="text-center">
                  {{ item.total_items }}
                </td>
                <td
                  v-if="item.customer && item.customer.name"
                  class="text-center"
                >
                  {{ item.customer.name }}
                </td>
                <td v-if="item.shop && item.shop.name" class="text-center">
                  {{ item.shop.name }}
                </td>
                <td class="text-center">
                  {{ item.sale_type }}
                </td>
                <td class="text-center">
                  <p
                    style="
                      color: #ffffff !important;
                      line-height: 1.5;
                      border-radius: 4px !important;
                      font-size: 10px;
                      height: 16px;
                      align-items: center;
                    "
                    :style="
                      item.status == 'Completed'
                        ? 'background-color: #4CAF50 !important; '
                        : 'background-color: #555555 !important'
                    "
                  >
                    {{ item.status }}
                  </p>
                </td>
                <td class="text-center">
                  <i
                    v-if="item.total_items != 0 && !item.saleReturn.length > 0"
                    class="fa fa-shopping-cart"
                    aria-hidden="true"
                    style="color: red; padding-right: 5px"
                    @click="activeSalesReturn(item)"
                    data-toggle="tooltip"
                    data-placement="top"
                    data-custom-class="tooltip-primary"
                    title="Sale Return"
                  />
                  <i
                    v-else
                    class="fa fa-shopping-cart"
                    aria-hidden="true"
                    style="color: gray; padding-right: 5px"
                    data-toggle="tooltip"
                    data-placement="top"
                    data-custom-class="tooltip-primary"
                    title="Already Sale Return"
                  />
                  <i
                    v-b-toggle.return-sidebar
                    class="fa fa-print"
                    aria-hidden="true"
                    style="color: blue"
                    @click="onSelect(item.id)"
                    data-toggle="tooltip"
                    data-placement="top"
                    data-custom-class="tooltip-primary"
                    title="Previus Bill"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </b-modal>
    <Sidebar id="return-sidebar" :width="500" title="Sales Details" right>
      <PrintBill />
    </Sidebar>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import Sidebar from "@/components/base/Sidebar";
import PrintBill from "./PrintBill";

export default {
  name: "SalesDetails",

  components: {
    Sidebar,
    PrintBill,
  },

  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data: () => ({
    loading: null,
    selected: {},
    customer: null,
    shop: null,
    fetchCount: 0,
    removeSalesLoading: false,
    query: null,
    selectedCustomer: null,
    customerSearchList: [{ name: "Walk in customer", id: 1 }],
    shopSearchList: [{ name: "DEFAULT", id: 1 }],
    selectedShop: null,
    salesReturnVisible: nulll,
  }),
  methods: {
    // Selected Item For Sales ReturnFunction
    async onChangeCustomer(value) {
      this.customer = value?.id;
      await this.fetchSales();
    },

    onChangeShop(value) {
      this.shop = value?.id;
      this.fetchSales();
    },
    activeSalesReturn(event) {
      this.salesReturnVisible = true;
      this.$store.dispatch("salesReturn/setSalesReturnDatas", event);
      this.$store.dispatch(
        "salesReturn/setVisibleSalesReturn",
        this.salesReturnVisible
      );

      this.$store.dispatch("salesReturn/fetchProductsSalesReturn", {
        salesid: event.id,
      });
      this.$store.dispatch("shops/fetchCashflowData");
      this.hideModal();
    },

    searchCustomer(search, loading) {
      this.$store
        .dispatch("customer/search", { query: search })
        .then((res) => {
          this.customerSearchList = res.data.data;
        })
        .catch((err) => {});
    },

    searchShop(search, loading) {
      this.$store
        .dispatch("shops/search", { query: search })
        .then((res) => {
          this.shopSearchList = res.data.data;
        })
        .catch((err) => {});
    },

    moment(date) {
      return moment(date).format("LL");
    },
    fetchSales() {
      this.loading1 = true;
      this.$store
        .dispatch("sales/fetchSales", {
          query: this.query,
          customer: this.customer,
          shop: this.shop,
        })
        .then((res) => {
          this.loading1 = false;
          // this.sales = res;
        })
        .catch((err) => {
          this.loading1 = false;
          this.sales = [];
        });
    },

    showModal() {
      this.loading = true;

      setTimeout(() => {
        this.fetchSales();
      }, 200);
      this.$refs.ModalUnitAndBatch.show();
      this.loading = false;
    },
    hideModal() {
      this.$refs.ModalUnitAndBatch.hide();
    },

    onSelect(id) {
      this.fetchReturnInfo(id);
      this.hideModal();
    },
    fetchReturnInfo(id) {
      this.$store.dispatch("sales/fetchSalesInfo", { id });
    },
  },

  computed: {
    ...mapState("sales", ["sales"]),
    ...mapState("salesReturn", ["sales_return_details"]),
    ...mapState("salesReturn", ["sales_return_products"]),
  },

  created() {
    this.searchCustomer();
    this.searchShop();
  },
};
</script>
<style scoped>
.returnButton {
  height: 29px;
  width: 62px;
  color: white;
  background: blueviolet;
  border-radius: 17px;
  border: antiquewhite;
}
</style>
